/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 18:36:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-24 18:40:54
 * @FilePath: /unifyxp-v2-store-portal/src/components/Link/GreenText/index.tsx
 */
import React from 'react';

import css from './css.less';

import Link from '../Link';
import { ArrowRightOutlined } from '@ant-design/icons';

const GreenLink = (props) => {
  const { to, className, children, onClick, disable, hideArrow } = props;
  return (
    <Link
      to={to}
      onClick={onClick}
      disable={disable}
      className={css.jumpContainer + ' ' + className || ''}>
      {!hideArrow && <ArrowRightOutlined className={css.icon} />}
      {children}
    </Link>
  );
};
export default GreenLink;
